import { Component, Vue } from "vue-property-decorator";
import { PageableSearchResult, SearchResult } from "@scrile/api-provider/dist/api/types";
import {
  ContentFeed,
  ContentFeedSearchResult,
  InputContentFeedSearch,
  InputDiscoveryContentFeedSearch,
  InputFollowingContentFeedSearch,
} from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import providers from "@/lib/api";

interface PageableSearchInput {
  page?: number;
}

const iterativelyFindFeedItem = async <
  T extends PageableSearchInput,
  R extends PageableSearchResult & SearchResult<ContentFeed>
>(
  feedIdToFind: string,
  data: T,
  searchFunc: (payload: { data: T }) => Promise<R>
): Promise<R> => {
  let resp = await searchFunc.call(providers.ContentFeedProvider, { data });
  while (resp.result.findIndex(i => i.id === feedIdToFind) === -1 && resp.hasNextPage) {
    data.page = (data.page ?? 0) + 1;
    const currentResult = resp.result;
    resp = await searchFunc.call(providers.ContentFeedProvider, { data });
    resp.result = currentResult.concat(resp.result);
  }
  return resp;
};

@Component
export default class WithContentFeed extends Vue {
  public async contentFeedSearch(data: InputContentFeedSearch, feedIdToFind?: string) {
    let response: ContentFeedSearchResult;
    if (feedIdToFind) {
      response = await iterativelyFindFeedItem(feedIdToFind, data, providers.ContentFeedProvider.search);
    } else response = await providers.ContentFeedProvider.search({ data });
    return response;
  }

  public async contentFeedFollowingSearch(data: InputFollowingContentFeedSearch, feedIdToFind?: string) {
    let response: ContentFeedSearchResult;
    if (feedIdToFind) {
      response = await iterativelyFindFeedItem(
        feedIdToFind,
        data,
        providers.ContentFeedProvider.followingContentFeedSearch
      );
    } else response = await providers.ContentFeedProvider.followingContentFeedSearch({ data });
    return response;
  }

  public async contentFeedDiscoverySearch(data: InputDiscoveryContentFeedSearch, feedIdToFind?: string) {
    let response: ContentFeedSearchResult;
    if (feedIdToFind) {
      response = await iterativelyFindFeedItem(
        feedIdToFind,
        data,
        providers.ContentFeedProvider.discoveryContentFeedSearch
      );
    } else response = await providers.ContentFeedProvider.discoveryContentFeedSearch({ data });
    return response;
  }

  public contentFeedDeletePost(id: string) {
    return providers.ContentSetProvider.delete({ id });
  }
  public async contentFeedStatsGetCount(userId: string, type: string) {
    const resp = await providers.ContentSetProvider.getStatistic({ data: { userIds: [userId], type: type } });
    return resp[userId];
  }
}
